import { render, staticRenderFns } from "./StaffEdit.vue?vue&type=template&id=389d556c&"
import script from "./StaffEdit.vue?vue&type=script&lang=js&"
export * from "./StaffEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports